function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M396.8,47.2H17.6C8,47.2,0,55.2,0,64.8v236.8c0,9.6,8,17.6,17.6,17.6H160v32h-37.6c-4.8,0-8,3.2-8,8s3.2,8,8,8H168h78.4 h43.2c4.8,0,8-3.2,8-8s-3.2-8-8-8h-35.2v-32h142.4c9.6,0,17.6-8,17.6-17.6V64.8C414.4,55.2,406.4,47.2,396.8,47.2z M238.4,351.2 H176v-32h62.4V351.2z M398.4,301.6c0,0.8-0.8,1.6-1.6,1.6H246.4H168H17.6c-0.8,0-1.6-0.8-1.6-1.6V64.8c0-0.8,0.8-1.6,1.6-1.6 h379.2c0.8,0,1.6,0.8,1.6,1.6V301.6z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M319.2,111.2c-9.6,0-17.6,8-17.6,17.6c0,2.4,0.8,5.6,1.6,7.2l-56.8,64.8c-1.6-0.8-4-1.6-6.4-1.6c-2.4,0-5.6,0.8-8,1.6 l-40-41.6c0-1.6,0.8-2.4,0.8-4c0-9.6-8-17.6-17.6-17.6c-9.6,0-17.6,8-17.6,17.6c0,1.6,0,2.4,0,4l-59.2,59.2 c-1.6-0.8-3.2-0.8-4.8-0.8c-9.6,0-17.6,8-17.6,17.6c0,9.6,8,17.6,17.6,17.6s17.6-8,17.6-17.6c0-2.4-0.8-4.8-1.6-6.4l56.8-56.8 c2.4,0.8,4.8,1.6,7.2,1.6c2.4,0,4.8-0.8,7.2-1.6l40,42.4c0,0.8,0,2.4,0,3.2c0,9.6,8,17.6,17.6,17.6c9.6,0,17.6-8,17.6-17.6 c0-1.6,0-3.2-0.8-4.8l59.2-66.4c0.8,0,2.4,0,3.2,0c9.6,0,17.6-8,17.6-17.6C336.8,119.2,328.8,111.2,319.2,111.2z"
})));

function SvgDiagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 414.4 414.4",
    style: {
      enableBackground: "new 0 0 414.4 414.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.21082a61.svg";
export { ForwardRef as ReactComponent };